import * as React from 'react'
import { Typography } from '@mui/material'
import SenderNameSettings from '@/components/notification-send/SenderNameSettings'
import { getSenderName } from '@/services/notificationService'

// Missing/invalid accountId must become NaN, never the silent 0 that
// Number(null) would produce (repo convention, see src/pages/Consumers.tsx).
const readAccountId = (): number => {
  const raw = localStorage.getItem('accountId')
  return raw ? Number(raw) : NaN
}

const SenderNamePanel = () => {
  const accountId = readAccountId()
  const [currentName, setCurrentName] = React.useState<string | null>(null)

  React.useEffect(() => {
    if (!Number.isFinite(accountId)) return
    let cancelled = false
    getSenderName(accountId)
      .then(name => {
        if (!cancelled) setCurrentName(name)
      })
      .catch(() => {
        /* saved-name display is best-effort; the verify flow still works */
      })
    return () => {
      cancelled = true
    }
  }, [accountId])

  if (!Number.isFinite(accountId)) {
    return (
      <Typography sx={{ direction: 'rtl' }}>
        פרטי החשבון חסרים — התחברו מחדש כדי לערוך את שם השולח
      </Typography>
    )
  }

  // SenderNameSettings seeds its field with useState(currentName ?? ''), which
  // ignores later prop changes; remount it on key when the fetch lands.
  return (
    <SenderNameSettings
      key={currentName ?? ''}
      accountId={accountId}
      currentName={currentName}
    />
  )
}

export default SenderNamePanel
